import { Box, Select as NDSSelect } from "@nulogy/components";
import endpoints from "config/endpoints";
import flatMap from "lodash/flatMap";
import React from "react";
import styled from "styled-components";

const Wrapper = styled(Box)`
  width: 250px;
`;

const Select = styled(NDSSelect)`
  .ndsSelect__value-container {
    overflow: hidden;
  }

  > div {
    width: 250px;
    font-size: 16px;
  }
`;

export default function SiteSwitcherView({ companies, currentSiteId, ...props }) {
  const options = flatMap(companies, (sites, companyName) =>
    sites.map((site) => ({ label: siteLabel(companies, companyName, site.name), value: site.id })),
  );

  return (
    <Wrapper>
      <Select
        className="spec-site-switcher"
        maxHeight="250"
        onChange={handleChange}
        options={options}
        value={currentSiteId}
        {...props}
      />
    </Wrapper>
  );
}

function siteLabel(companies, companyName, siteName) {
  if (Object.keys(companies).length > 1) {
    return `${companyName} - ${siteName}`;
  }
  return siteName;
}

const handleChange = (siteId) => {
  window.location.href = siteLink(siteId);
};

function siteLink(siteId) {
  return `${endpoints.switchSite(siteId)}?redirect_url=${window.location.origin}`;
}
